import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export interface RemoveUsers {
  modifiedByPersonId: string;
  userId: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    removeUserAccessBulkAction: builder.mutation<
      void,
      {
        accountId: string;
        removeUsers: RemoveUsers[];
      }
    >({
      query: ({ accountId, removeUsers }) => ({
        url: `v4/accounts/${accountId}/users:bulk`,
        method: 'DELETE',
        body: { removeUsers },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useRemoveUserAccessBulkActionMutation } = apiSlice;
